import {FETCH_IMAGES_AND_USER_FAILURE, FETCH_IMAGES_AND_USER_REQUEST, FETCH_IMAGES_AND_USER_SUCCESS} from '../actions/ImageActions';
import get from 'lodash/get';

const extractUserId = (action) => {
    return action.userId || get(action, 'user.id', get(action, 'image.userId', get(action, 'imageInfo.userId')));
};

export function imagesFetchStatus(state = {}, action) {
    switch (action.type) {
        case FETCH_IMAGES_AND_USER_REQUEST: {
            const userId = extractUserId(action);
            return {...state, [userId]: {fetched: null, fetching: true}};
        }
        case FETCH_IMAGES_AND_USER_SUCCESS: {
            const userId = extractUserId(action);
            return {...state, [userId]: {fetched: new Date(), fetching: false, error: null}};
        }
        case FETCH_IMAGES_AND_USER_FAILURE: {
            const userId = extractUserId(action);
            return {...state, [userId]: {fetched: null, fetching: false, error: action.error}};
        }
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/imagesFetchStatus.js